import React, { useState, useRef } from "react";

interface IProps {
    options: { value: number, label: string }[]
    value: number
    onChange: (value: number) => void
}

const WheelPickerDialog = (props: IProps) => {
    const listRef = useRef<HTMLUListElement | null>(null);
    const [selectedIndex, setSelectedIndex] = useState<number>(0);
    const itemHeight = 50;

    React.useEffect(() => {
        if (props.value || props.value == 0) {
            var index = props.options.findIndex(x => x.value == props.value)
            if (index > -1)
                handleItemClick(index, "auto");
        }
    }, [props.value])

    const handleItemClick = (index: number, behavior: "smooth" | "auto") => {
        if (index !== selectedIndex) {
            setSelectedIndex(index);
            if (listRef.current) {
                const scrollPosition = index * itemHeight;
                listRef.current.scrollTo({
                    top: scrollPosition,
                    behavior: behavior
                });
            }
            // if (listRef.current) {
            //     listRef.current.children[index].scrollIntoView({
            //         behavior: behavior,
            //         block: 'start'
            //     });
            // }
            props.onChange(props.options[index]?.value)
        }
    };

    const handleScroll = (e: any) => {
        if (e.target) {
            const newIndex = Math.round(e.target.scrollTop / itemHeight);
            if (newIndex !== selectedIndex) {
                setSelectedIndex(newIndex);
                props.onChange(props.options[newIndex]?.value)
            }
        }
    };

    return (
        <React.Fragment>
            <div className={`relative overflow-hidden`} style={{ height: `${itemHeight * 3}px` }}>
                <ul
                    ref={listRef}
                    onScroll={handleScroll}
                    className="no-scrollbar h-full overflow-y-scroll snap-y snap-mandatory"
                    style={{
                        padding: 0,
                        margin: 0,
                        overflowY: 'scroll',
                        scrollSnapType: 'y mandatory'
                    }}>
                    <li
                        key={-1}
                        className={`flex justify-center items-center snap-center transition-opacity`}
                        style={{ height: `${itemHeight}px`, opacity: 0, transition: "opacity 0.3s", pointerEvents: "none" }}>
                    </li>
                    {props.options.map((item, index) => {
                        const isSelected = index === selectedIndex;
                        const isBeforeOrAfter = Math.abs(index - selectedIndex) === 1;

                        return (
                            <li
                                key={index}
                                className={`flex justify-center items-center snap-center transition-opacity ${isSelected
                                    ? "text-blue-500 font-semibold"
                                    : isBeforeOrAfter
                                        ? "opacity-50"
                                        : "opacity-0"
                                    }`}
                                style={{
                                    height: `${itemHeight}px`,
                                    opacity: isSelected ? 1 : isBeforeOrAfter ? 0.9 : 0,
                                    transition: "opacity 0.3s",
                                    color: isSelected ? "blue" : "gray",
                                    cursor: "pointer"
                                }}
                                onClick={() => handleItemClick(index, "smooth")}>
                                {isSelected ?
                                    <h4>{item.label}</h4>
                                    :
                                    <span>{item.label}</span>}
                            </li>
                        );
                    })}
                    <li
                        key={-2}
                        className={`flex justify-center items-center snap-center transition-opacity z-0`}
                        style={{ height: `${itemHeight}px`, opacity: 0, transition: "opacity 0.3s", pointerEvents: "none" }}>
                    </li>
                </ul>

                <div className={`absolute top-0 left-0 right-0 bg-gradient-to-b from-white to-transparent pointer-events-none`}
                    style={{ height: `${itemHeight}px`, top: 0, left: 0, right: 0, background: "linear-gradient(to bottom, white, transparent)", pointerEvents: "none" }} />
                <div className={`absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white to-transparent pointer-events-none`}
                    style={{ height: `${itemHeight}px`, bottom: 0, left: 0, right: 0, background: "linear-gradient(to bottom, white, transparent)", pointerEvents: "none" }} />
            </div>
            <style>
                {`
                ul::-webkit-scrollbar{
                    display: none;
                }`}
            </style>
        </React.Fragment>
    );
};

export default WheelPickerDialog;